export default __webpack_public_path__ + "static/media/family-icon.a9fb0475.svg";